import { dateTimeSqlToDateTimeBR } from './date'

const createdUpdatedUser = (userName, date) => {
  return userName !== null && userName !== ''
    ? `${userName} em ${dateTimeSqlToDateTimeBR(date)}`
    : '-'
}

const statusTranslate = (value) => {
  const status = parseInt(value, 10)
  switch (status) {
    case 0:
      return '<span class="badge bg-danger">Inativo</span>'
    case 1:
      return '<span class="badge bg-success">Ativo</span>'
    case 2:
      return '<span class="badge bg-warning">Em Edição</span>'
    default:
      return '<span class="badge bg-secondary">Indefinido</span>'
  }
}

const typeCourse = (value) => {
  const status = parseInt(value, 10)
  switch (status) {
    case 1:
      return '<span class="badge bg-danger bg-opacity-20 text-danger">ETHOS</span>'
    case 2:
      return '<span class="badge bg-secondary bg-opacity-20 text-secondary">EMPRESA</span>'
    default:
      return '<span class="badge bg-secondary bg-opacity-20 text-secondary">Indefinido</span>'
  }
}

const moneyToCurrencyBr = (value) => {
  if (value !== null && value !== '') {
    const money = parseFloat(value)
    return money.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  }
  return value
}

export { createdUpdatedUser, statusTranslate, typeCourse, moneyToCurrencyBr }
